// extracted by mini-css-extract-plugin
module.exports = {"Root":"Icon_Root__18A2W","Inline":"Icon_Inline__3EP0Q","Margin":"Icon_Margin__3zeAP"};